export const APPLICATION_FORMAT_EMAIL = 'email';
export const APPLICATION_FORMAT_URL = 'url';